angular.module('unergie.main')
.directive('changeNominal', ($filter, $uibModal, AlertManager, ApiUser, BoFeaturesService, AdminComments, ErrorCatcher) => ({
    restrict: 'E',
    scope: {
        account: '=',
        onNominalChange: '&?',
    },
    templateUrl: '/directives/changeNominal/changeNominal.html',
    link($scope) {
        const feats = BoFeaturesService.getModuleFeatures('accountinfo')
        $scope.isAIFeatureOn = (feature) => feats[feature]

        $scope.nominalPayload = {
            civ: '',
            givenname: '',
            sn: '',
        }
        $scope.nominalFields = {
            civ: {
                label: 'Civilité',
                type: 'select',
                enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }],
            },
            givenname: {
                label: 'Prénom',
                type: 'text',
            },
            sn: {
                label: 'Nom',
                type: 'text',
                forceUppercase: true,
            },
        }

        $scope.initChangeNominal = () => {
            $scope.nominalPayload = {
                civ: $scope.account.civ,
                givenname: $scope.account.givenname,
                sn: $scope.account.sn,
            }
        }

        $scope.changeNominal = () => {
            return ApiUser.updateAccount({ id_account: $scope.account.id }, $scope.nominalPayload).$promise.then(() => {
                AlertManager.success('Compte modifiée')
                const comment = `<b>AUTOMATIQUE</b> : Civilité mise à jour : <b>${$scope.account.civ} ${$scope.account.sn} ${$scope.account.givenname}</b>`
                AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                $scope.onNominalChange({ newNominal: _.clone($scope.nominalPayload) })
            }).catch(ErrorCatcher)
        }
    },
}))
